import { render, staticRenderFns } from "./system_app_settings.vue?vue&type=template&id=1d7227c8&scoped=true&"
import script from "./system_app_settings.vue?vue&type=script&lang=js&"
export * from "./system_app_settings.vue?vue&type=script&lang=js&"
import style0 from "./system_app_settings.vue?vue&type=style&index=0&id=1d7227c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7227c8",
  null
  
)

export default component.exports